export class MinDTO {
    id: number;
    name: string;
}